var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import { Search, SearchOff } from '@mui/icons-material';
export var DefaultButtonsListView = function (_a) {
    var handleFind = _a.handleFind, handleClear = _a.handleClear;
    return (_jsxs(Box, __assign({ sx: {
            display: 'flex',
            justifyContent: 'right',
            gap: 1,
            marginTop: 2,
            flexDirection: {
                xs: 'column',
                sm: 'column',
                md: 'row',
            },
            alignItems: {
                xs: 'stretch',
                sm: 'stretch',
                md: 'center',
            },
        } }, { children: [_jsx(Button, __assign({ color: "primary", variant: "contained", onClick: handleFind, endIcon: _jsx(Search, {}) }, { children: "Buscar" })), _jsx(Button, __assign({ color: "primary", variant: "outlined", onClick: handleClear, endIcon: _jsx(SearchOff, {}) }, { children: "Limpar" }))] })));
};
